module.exports = __webpack_public_path__ + "img/al.633aef5e.png";